<!-- Dialog title -->
<form [formGroup]="shareQuotationForm" class="padding-res">
  <!-- Dialog content -->
  <div mat-dialog-content class="mt-2 share-quotes">
    <div class="d-flex justify-content-between">
      <div class="plans-name">
        <div class="header-share-text">Share selected quotes</div>
        <div *ngFor="let value of quotesData; let i = index">
          <span
            class="header-sub-text"
            [matTooltip]="i >= 2 ? getRemainingInsurerNames() : null"
            *ngIf="i < 2"
          >
            {{ value?.insurer_name }}
          </span>
        </div>
        <span
          class="header-sub-text color-primary"
          *ngIf="quotesData?.length > 2"
          [matTooltip]="getRemainingInsurerNames()"
        >
          +{{ quotesData.length - 2 }} more
        </span>
      </div>
      <div class="cross">
        <img
          src="assets/icon/cross.svg"
          (click)="onClose()"
          class="cursor-pointer"
          alt="close"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <mat-form-field
          appearance="outline"
          class="mat-input-share-social-media"
        >
          <mat-label>Enter WhatsApp Number</mat-label>
          <input
            matInput
            aria-label="whatsApp_number"
            formControlName="whatsApp_number"
            maxlength="10"
            appNumbersOnly
          />
          <button
            class="social-media-image"
            *ngIf="!whatsappShareLoader"
            (click)="shareQuotes('whatsapp')"
            [disabled]="true"
          >
            <img
              src="assets/icon/whatsapp.svg"
              class="whatsapp-image"
              alt="close"
            />
          </button>
          <div class="social-media-image" *ngIf="whatsappShareLoader">
            <img class="loader" src="assets/gif/shareLoader.gif" alt="" />
          </div>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="outline"
          class="mat-input-share-social-media"
        >
          <mat-label>Enter Contact Number</mat-label>
          <input
            matInput
            aria-label="contact_number"
            formControlName="contact_number"
            maxlength="10"
            appNumbersOnly
          />
          <button
            class="social-media-image"
            (click)="shareQuotes('mobile')"
            [disabled]="shareQuotationForm.invalid"
            *ngIf="!mobileShareLoader"
          >
            <img src="assets/icon/sms.svg" class="whatsapp-image" alt="close" />
          </button>
          <div class="social-media-image" *ngIf="mobileShareLoader">
            <img class="loader" src="assets/gif/shareLoader.gif" alt="" />
          </div>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field
          appearance="outline"
          class="mat-input-share-social-media"
        >
          <mat-label>Enter Email</mat-label>
          <input
            matInput
            aria-label="email"
            formControlName="email"
            appNotAllowDot
          />
          <button
            class="social-media-image"
            type="submit"
            (click)="shareQuotes('email')"
            [disabled]="shareQuotationForm.invalid"
            *ngIf="!emailShareLoader"
          >
            <img
              src="assets/icon/mail.svg"
              class="whatsapp-image"
              alt="close"
            />
          </button>
          <div class="social-media-image" *ngIf="emailShareLoader">
            <img class="loader" src="assets/gif/shareLoader.gif" alt="" />
          </div>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
